import { BaseButton, type BaseButtonProps } from '@/src/components/buttons/BaseButton'
import { forwardRef } from '@chakra-ui/react'
import { ChevronLeft } from 'react-feather'
import { useTranslation } from 'react-i18next'

export const BackButton = forwardRef<Partial<BaseButtonProps>, 'button'>((props, ref) => {
  const { t } = useTranslation()
  return (
    <BaseButton
      text={props.text ?? t('common.back')}
      size='medium'
      w={'fit-content'}
      iconLeft={<ChevronLeft width={'24px'} height={'24px'} />}
      {...props}
      variant={props.variant ?? 'tertiary'}
    />
  )
})
